import { Component, inject, Input } from '@angular/core'
import { CMInput, CMLayerInput, DynamicCMInputOptions } from '@core/models/calculation-module.model'
import { CalculationModuleService } from '@core/services/calculation-module.service'
import { CmInputComponent } from '../cm-input/cm-input.component'
import { DynamicCmInputArrayComponent } from '../dynamic-cm-inputs-array/dynamic-cm-inputs-array.component'

@Component({
  selector: 'app-dynamic-cm-inputs-options',
  templateUrl: './dynamic-cm-inputs-options.component.html',
  styleUrl: './dynamic-cm-inputs-options.component.scss',
  imports: [
    // Components
    CmInputComponent,
    DynamicCmInputArrayComponent,
  ],
})
export class DynamicCmInputsOptionsComponent {
  @Input({ required: true }) dynamicCMInputOptions!: DynamicCMInputOptions // Received from SSOT
  calculationModuleService = inject(CalculationModuleService)
  dynamicInputName: string = ''

  ngOnChanges() {
    this.dynamicInputName = this.dynamicCMInputOptions.input_name

    const parentInput = this.dynamicCMInputOptions.parent_input
    if (
      this.calculationModuleService.isCMLayerInput(parentInput) &&
      parentInput.input_value === ''
    ) {
      this.calculationModuleService.updateDynamicCMInputOptionsParentInput(
        parentInput.input_options_array[0],
        parentInput,
        this.dynamicCMInputOptions,
      )
    }
  }

  // Updates SSOT when the parent input is a regular CMInput
  onParentInputChange(event: { value: any; input: CMInput }) {
    const { value, input } = event
    this.calculationModuleService.updateDynamicCMInputOptionsParentInput(
      value,
      input,
      this.dynamicCMInputOptions,
    )
  }

  // Updates SSOT when the parent input is a Layer CMInput
  onParentLayerInputChange(event: { layerInput: CMLayerInput; selectedLayerName: string }) {
    const { layerInput, selectedLayerName } = event
    const selectedLayer = layerInput.layers.find((layer) => layer.name === selectedLayerName)
    if (!selectedLayer) {
      return
    }
    this.calculationModuleService.setLayerNeededParentInput(layerInput, selectedLayer)
  }
}
